import nodeLinkPropertiesQuery from '@aurora/shared-client/components/nodes/NodeProperties/NodeLinkProperties.query.graphql';
import useQueryWithTracing from '@aurora/shared-client/components/useQueryWithTracing';
import type {
  NodeLinkPropertiesQuery,
  NodeLinkPropertiesQueryVariables
} from '@aurora/shared-generated/types/graphql-types';

/**
 * Properties related to link.
 */
interface LinkPropertiesType {
  /**
   * Is External Link warning enabled
   */
  isExternalLinkWarningEnabled: boolean;
  /**
   * Whether the link properties query is loading.
   */
  linkPropertiesLoading: boolean;
}

/**
 * Get Link properties at a node level
 *
 * @author Kunal Punjrath
 * @param nodeId a core node id
 */
export default function useLinkProperties(nodeId: string): LinkPropertiesType {
  const { data: linkPropertiesData, loading: linkPropertiesLoading } = useQueryWithTracing<
    NodeLinkPropertiesQuery,
    NodeLinkPropertiesQueryVariables
  >(module, nodeLinkPropertiesQuery, {
    variables: {
      nodeId
    },
    skip: !nodeId
  });

  return {
    isExternalLinkWarningEnabled:
      linkPropertiesData?.coreNode?.linkProperties?.isExternalLinkWarningEnabled,
    linkPropertiesLoading
  };
}
